import { render, staticRenderFns } from "./BookSuccess.vue?vue&type=template&id=1f0220d1"
import script from "./BookSuccess.vue?vue&type=script&lang=js"
export * from "./BookSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports